// extracted by mini-css-extract-plugin
export var colorSquare = "_ul-0";
export var danger = "_ul-5";
export var lightPink = "_ul-8";
export var neutralBlue = "_ul-7";
export var neutralYellow = "_ul-6";
export var normal = "_ul-1";
export var primary = "_ul-2";
export var primaryLight = "_ul-3";
export var solidBlack = "_ul-g";
export var solidGreen = "_ul-b";
export var solidLightBlue = "_ul-d";
export var solidNavy = "_ul-c";
export var solidOrange = "_ul-f";
export var solidPink = "_ul-e";
export var solidRed = "_ul-9";
export var solidYellow = "_ul-a";
export var success = "_ul-4";